import React from 'react';
import LoadingOverlay from 'swag-client-common/components/ui/loading-overlay';
import { LoadingOverlayBackgroundType } from 'swag-client-common/components/ui/loading-overlay/loading-overlay';
import { InfoPage } from '../info-page';
import { ImageLoading } from '../image-loading';
import classes from './giveaway-info-page.scss';
export class GiveawayInfoPageComponent extends React.Component {
  render() {
    const {
      link,
      giveaway,
      isImagesInLoading,
      title,
      subtitle,
      saveFeedback,
      giveawayColor,
      backgroundColor
    } = this.props;
    if (!giveaway) {
      return null;
    }
    const {
      logo
    } = giveaway;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(LoadingOverlay, {
      isShown: isImagesInLoading,
      backgroundType: LoadingOverlayBackgroundType.white,
      wavedLoader: true
    }), /*#__PURE__*/React.createElement(InfoPage, {
      dataProps: String(link ? link._id : 'preview'),
      title: title,
      subtitle: subtitle,
      logo: /*#__PURE__*/React.createElement(ImageLoading, {
        src: logo,
        alt: "logo",
        className: classes.logo
      }),
      primaryColor: giveawayColor,
      status: link === null || link === void 0 ? void 0 : link.status,
      feedback: link === null || link === void 0 ? void 0 : link.feedback,
      saveFeedback: saveFeedback,
      backgroundColor: backgroundColor
    }));
  }
}